import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Checkbox } from "../../../components/ui/checkbox";

export const STATUSES = [
  {
    id: "new_booking",
    label: "New Booking",
  },
  {
    id: "booking_checked",
    label: "Booking Checked",
  },
  {
    id: "on_charter",
    label: "On Charter",
  },
  {
    id: "completed_charter",
    label: "Completed Charter",
  },
  {
    id: "booking_cancelled",
    label: "Booking Cancelled",
  },
];

export const Status = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Status</h3>
      <FormField<FiltersFormT, "status">
        name="status"
        render={() => (
          <FormItem>
            {STATUSES.map((item) => (
              <FormField
                key={item.id}
                name="status"
                render={({ field }) => {
                  return (
                    <FormItem key={item.id} className="flex flex-row items-start space-x-3 space-y-0">
                      <FormControl>
                        <Checkbox
                          className="w-6 h-6"
                          checked={field.value?.includes(item.id)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, item.id])
                              : field.onChange(field.value?.filter((value: string) => value !== item.id));
                          }}
                        />
                      </FormControl>
                      <FormLabel className="font-normal text-base leading-6">{item.label}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </FormItem>
        )}
      />
    </div>
  );
};
